import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Icon from "../components/Icon";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | PT. Bumi Cakrawala Logistik</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="notfound">
        <span className="notfound__code">ERROR 404 &middot; MANIFEST NOT FOUND</span>
        <h1>404</h1>
        <p>The page you&rsquo;re looking for has been rerouted or doesn&rsquo;t exist. Let&rsquo;s get you back on track.</p>
        <Link to="/" className="btn btn-primary">
          Back to Home <Icon name="arrowRight" size={18} />
        </Link>
      </div>
    </>
  );
}
